export const tableHeaderJobData = [
  {
    id: 1,
    headerClassName: 'w-[7%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[7%] break-all pl-2',
    label: 'Job Id',
  },
  {
    id: 2,
    headerClassName: 'w-[15%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[15%] text-pretty pl-2',
    label: 'Job Name',
    isFilter: true,
  },
  {
    id: 3,
    headerClassName: 'w-[10%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[10%] break-all pl-2',
    label: 'Stage Date',
  },
  {
    id: 4,
    headerClassName: 'w-[11%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[11%] break-all pl-2',
    label: 'Stage Completed',
  },
  {
    id: 5,
    headerClassName: 'w-[14%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[14%] break-all pl-2',
    label: 'Status',
  },
  {
    id: 6,
    headerClassName: 'w-[12%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[12%] break-all pl-2',
    label: 'PG Number',
  },
  {
    id: 7,
    headerClassName: 'w-[17%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[17%] break-all pl-2',
    label: 'Email',
  },
  {
    id: 8,
    headerClassName: 'w-[12%] pl-2',
    bodyClassName: 'flex flex-col justify-start w-[12%] break-all pl-2',
    label: 'Text No',
  },
  {
    id: 9,
    headerClassName: 'w-[3%] ml-[0.7%]',
    bodyClassName: 'flex flex-col justify-start w-[3%] break-all pl-2',
    label: '', // Action
  },
]
